import { Component, ElementRef, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Observable, Subscription } from 'rxjs-compat';
import { EnviosPagedRequestDto } from '../../models/envios-filter';

@Component({
  selector: 'app-envios-filter',
  templateUrl: './envios-filter.component.html',
  styleUrls: ['./envios-filter.component.scss']
})
export class EnviosFilterComponent implements OnInit {
  subscription: Subscription;
  filter: EnviosPagedRequestDto;
  @Output() notify: EventEmitter<EnviosPagedRequestDto> = new EventEmitter<EnviosPagedRequestDto>();

  constructor(public thisDialogRef: MatDialogRef<EnviosPagedRequestDto>,
    @Inject(MAT_DIALOG_DATA) public data, ) {
      this.filter = data.filter;
    }

  ngOnInit() {
    this.subscription = Observable.fromEvent(document, 'keypress').subscribe((e: KeyboardEvent ) => {
      if (e.key === 'Enter') {
        this.apply();
      }
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  reset() {
    this.filter.clear();
    this.apply();
  }

  apply() {
    this.filter.updated();
    this.notify.emit(this.filter);
    this.thisDialogRef.close();
  }

  dismiss() {
    this.thisDialogRef.close();
  }
}
